module.exports = __webpack_public_path__ + "assets/certification-mobile.06bcacd71ba9194561b33ca3d8c984c8.png";